import { useState } from "react";
import type { FaqItem } from "@/types/content";

export default function FaqAccordion({
  items,
  defaultOpen = 0,
}: {
  items: FaqItem[];
  defaultOpen?: number | null;
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <div className="w-full divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-6 md:py-5"
              >
                <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                  {item.question}
                </span>
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-colors ${
                    isOpen
                      ? "border-primary-300 bg-primary-100 text-primary-700"
                      : "border-background-300 text-foreground-500"
                  }`}
                >
                  <i
                    className={isOpen ? "ri-subtract-line text-base" : "ri-add-line text-base"}
                  ></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-4 pb-4 md:px-6 md:pb-6">
                <p className="max-w-3xl text-sm leading-relaxed text-foreground-600">
                  {item.answer}
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}